module.exports = __webpack_public_path__ + "img/image02.0a58c25f.jpg";